import GSAP from 'gsap'
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { DOMAnimations } from '../libs/dom'

class Service {
  constructor() {
    this.init()
  }

  init() {
    this.toggleInfo()
  }

  toggleInfo() {
    this.isTransitioning = false

    const buttons = document.querySelectorAll('.js-service__button')
    const contents = document.querySelectorAll('.js-service__content')

    buttons.forEach((button, i) => {
      button.addEventListener('click', async () => {
        const dataAttr = button.dataset
        const tab = document.querySelector(`[data-service-name="${dataAttr.service}"]`)

        if (this.isTransitioning) return

        buttons.forEach((b, itr) => b.classList.toggle('--is-active', itr === i))

        this.isTransitioning = true
        const promises = []

        contents.forEach((content, itr) => {
          const func = itr === i ? 'slideDown' : 'slideUp'
          promises.push(DOMAnimations[func](content))
        })

        await Promise.all(promises)
        this.isTransitioning = false
      })
    })
  }
}

export default Service
